// Journey track client — the stand's engine/journey.py endpoints (#4480):
// content from the overlay pack, state/tasks/stage/fork/stay. Every mutating
// call returns the fresh state view the screens render.
import { api } from '../../../api/client'
import { loadJourneyContent, type JourneyContent, type JourneyTaskDef } from '../../../entities/journey'

export interface JourneyTaskView extends JourneyTaskDef {
  done: boolean
  done_at?: string | null
  fork?: { options?: string[]; extend_max?: number } | null
}

export interface JourneyStageView {
  id: string
  no: number
  total: number
  phase?: string | null
  title: string
  focus?: string | null
  since?: string | null
  days?: number | null
  source?: string | null
}

export interface JourneyStateView {
  enabled: boolean
  stage: JourneyStageView | null
  weekly: JourneyTaskView[]
  daily: { task: JourneyTaskDef; status: 'open' | 'done' } | null
  pending_next: { id: string; title: string } | null
  extended: { count: number; max?: number; task_id?: string } | null
  finished: { kind: string } | null
  history: unknown[]
  sos: string[]
}

function localDate(): string {
  const now = new Date()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  return `${now.getFullYear()}-${month}-${day}`
}

export const journeyApi = {
  content: (): Promise<JourneyContent> => loadJourneyContent(),
  state: () => api.get<JourneyStateView>(`/engine/journey?date=${localDate()}`),
  setStage: (stageId: string) =>
    api.put<JourneyStateView>('/engine/journey/stage', { stage_id: stageId }),
  task: (taskId: string, done: boolean) =>
    api.post<JourneyStateView>('/engine/journey/task', { task_id: taskId, done, date: localDate() }),
  fork: (choice: 'split' | 'keep' | 'extend') =>
    api.post<JourneyStateView>('/engine/journey/fork', { choice }),
  stay: (stageId: string) =>
    api.post<JourneyStateView>('/engine/journey/stay', { stage_id: stageId }),
}
